import React, { useEffect } from "react";
import Scroller from "./add-on-template/Scroller";
import ai2html from "../ai2html-output/ai2html-chart";
import flowmapData from "../data/data.json";
// import remittancesRegions from '../data/remittances-regions.json'
import remittanceGrowthRateData from "../data/data.json";
import haiti from "../data/data.json";
import remittanceCost from "../data/data.json";
import remittanceFlowsData from "../data/data.json";
import educationSpending from "../data/data.json";
import costByProvider from "./../data/data.json";
import ContainerDimensions from "react-container-dimensions";
import LineChart from "./LineChart";
// import BubbleLineChart from './BubbleLineChart'
import RemittanceGrowthRate from "./RemittanceGrowthRate";
import RemittanceFlowChart from "./RemittanceFlowChart";
import EducationSpendingChart from "./EducationSpendingChart";
import RemittanceCostChart from "./RemittanceCostChart";
import CostByProviderChart from "./CostByProviderChart";
import Supplementary from "./core-template/Supplementary";

const Elements = (props) => {
  let el;
  const createMarkup = (text) => {
    return { __html: text };
  };
  const ai2htmlMap = {
    "dynamic-ai2html": ai2html,
  };

  if (props.type === "text") {
    el = (
      <div id={props.id} className="article-wrapper">
        <p dangerouslySetInnerHTML={createMarkup(props.text)}></p>
      </div>
    );
  } else if (props.type === "highlighted") {
    el = (
      <div id={props.id} className="article-wrapper highlighted-wrapper">
        <p className="factoid">{props.factoid}</p>
        <p>{props.text}</p>
      </div>
    );
  } else if (props.type === "subhed") {
    el = (
      <div id={props.id} className="article-wrapper">
        <h3 className="subhed">{props.text}</h3>
      </div>
    );
  } else if (props.type === "img") {
    const img = require(`./../img/${props.filename}`);
    el = (
      <div id={props.id} className="img-wrapper">
        <img src={img} alt={props.alt} />
      </div>
    );
  } else if (props.type === "chart") {
    const note = props.note ? (
      <p
        className="chart-note"
        dangerouslySetInnerHTML={createMarkup(props.note)}
      ></p>
    ) : (
      ""
    );
    el = (
      <div id={props.id} className="chart-wrapper">
        <p className="chart-title">{props.title}</p>
        <p className="chart-leadin">{props.subtitle}</p>
        <div className="chart"></div>
        {note}
        <p
          className="chart-source"
          dangerouslySetInnerHTML={createMarkup(props.source)}
        ></p>
      </div>
    );
  } else if (props.type === "scroller") {
    el = (
      // <ContainerDimensions>
      //   {({ width, height }) => (
      <Scroller
        props={{
          ...props,
          data: flowmapData,
        }}
      />
      //   )}
      // </ContainerDimensions>
    );
  } else if (props.type === "remittance-flow") {
    const note = props.note ? (
      <p
        className="chart-note"
        dangerouslySetInnerHTML={createMarkup(props.note)}
      ></p>
    ) : (
      ""
    );
    el = (
      <div id={props.id} className="chart-wrapper">
        <p className="chart-title">{props.title}</p>
        <p className="chart-leadin">{props.subtitle}</p>
        <div className="chart">
          <ContainerDimensions>
            {({ width, height }) => (
              <RemittanceFlowChart
                props={{
                  ...props,
                  data: remittanceFlowsData,
                  width: width,
                  height: height,
                }}
              />
            )}
          </ContainerDimensions>
        </div>
        {note}
        <p
          className="chart-source"
          dangerouslySetInnerHTML={createMarkup(props.source)}
        ></p>
      </div>
    );
  } else if (props.type === "linechart") {
    const note = props.note ? (
      <p
        className="chart-note"
        dangerouslySetInnerHTML={createMarkup(props.note)}
      ></p>
    ) : (
      ""
    );
    el = (
      <div id={props.id} className="chart-wrapper">
        <p className="chart-title">{props.title}</p>
        <p className="chart-leadin">{props.subtitle}</p>
        <div className="chart">
          <ContainerDimensions>
            {({ width, height }) => (
              <LineChart
                props={{
                  ...props,
                  data: haiti,
                  width: width,
                  height: height,
                }}
              />
            )}
          </ContainerDimensions>
        </div>
        {note}
        <p
          className="chart-source"
          dangerouslySetInnerHTML={createMarkup(props.source)}
        ></p>
      </div>
    );
  } else if (props.type === "remittance-growth-rate") {
    const note = props.note ? (
      <p
        className="chart-note"
        dangerouslySetInnerHTML={createMarkup(props.note)}
      ></p>
    ) : (
      ""
    );
    el = (
      <div id={props.id} className="chart-wrapper">
        <p className="chart-title">{props.title}</p>
        <p className="chart-leadin">{props.subtitle}</p>
        <div className="chart" style={{ height: "auto" }}>
          <ContainerDimensions>
            {({ width, height }) => (
              <RemittanceGrowthRate
                props={{
                  ...props,
                  data: remittanceGrowthRateData,
                  width: width,
                  height: height,
                }}
              />
            )}
          </ContainerDimensions>
        </div>
        {note}
        <p
          className="chart-source"
          dangerouslySetInnerHTML={createMarkup(props.source)}
        ></p>
      </div>
    );
  } else if (props.type === "education-spending-chart") {
    const note = props.note ? (
      <p
        className="chart-note"
        dangerouslySetInnerHTML={createMarkup(props.note)}
      ></p>
    ) : (
      ""
    );
    el = (
      <div id={props.id} className="chart-wrapper">
        <p className="chart-title">{props.title}</p>
        <p className="chart-leadin">{props.subtitle}</p>
        <div className="chart">
          <ContainerDimensions>
            {({ width, height }) => (
              <EducationSpendingChart
                props={{
                  ...props,
                  data: educationSpending,
                  width: width,
                  height: height,
                }}
              />
            )}
          </ContainerDimensions>
        </div>
        {note}
        <p
          className="chart-source"
          dangerouslySetInnerHTML={createMarkup(props.source)}
        ></p>
      </div>
    );
  } else if (props.type === "remittance-cost-chart") {
    const note = props.note ? (
      <p
        className="chart-note"
        dangerouslySetInnerHTML={createMarkup(props.note)}
      ></p>
    ) : (
      ""
    );
    el = (
      <div id={props.id} className="chart-wrapper">
        <p className="chart-title">{props.title}</p>
        <p className="chart-leadin">{props.subtitle}</p>
        <div className="chart">
          <ContainerDimensions>
            {({ width, height }) => (
              <RemittanceCostChart
                props={{
                  ...props,
                  data: remittanceCost,
                  width: width,
                  height: height,
                }}
              />
            )}
          </ContainerDimensions>
        </div>
        {note}
        <p
          className="chart-source"
          dangerouslySetInnerHTML={createMarkup(props.source)}
        ></p>
      </div>
    );
  } else if (props.type === "cost-by-provider-chart") {
    const note = props.note ? (
      <p
        className="chart-note"
        dangerouslySetInnerHTML={createMarkup(props.note)}
      ></p>
    ) : (
      ""
    );
    el = (
      <div id={props.id} className="chart-wrapper">
        <p className="chart-title">{props.title}</p>
        <p className="chart-leadin">{props.subtitle}</p>
        <div className="chart">
          <ContainerDimensions>
            {({ width, height }) => (
              <CostByProviderChart
                props={{
                  ...props,
                  data: costByProvider,
                  width: width,
                  height: height,
                }}
              />
            )}
          </ContainerDimensions>
        </div>
        {note}
        <p
          className="chart-source"
          dangerouslySetInnerHTML={createMarkup(props.source)}
        ></p>
      </div>
    );
  } else if (props.type === "ai2html") {
    el = (
      <div id={props.id} className="ai2html-wrapper chart-wrapper">
        <p dangerouslySetInnerHTML={createMarkup(ai2htmlMap[props.id])}></p>
      </div>
    );
  } else if (props.type === "supplementary") {
    el = (
      <div className="supplementary-wrapper">
        <div className="article-wrapper">
          <h3 className="subhed">{props.title}</h3>
          <p className="supplementary-instrux">{props.instruction}</p>
        </div>

        <Supplementary cards={props.charts.reverse()}></Supplementary>
      </div>
    );
  }

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    // your code here
  });

  return <>{el}</>;
};

export default Elements;
